// Module "Phiếu dịch vụ" (xưởng dịch vụ — BDSC + Bảo hiểm) — Phase 0 skeleton.
// BE: backend/src/modules/service-order (resource REST `service-orders`).
// Path `/service-orders` + folder `view/pages/service-orders/` + permission SERVICE_ORDER_*.

const ServiceOrder = () =>
  import(
    /* webpackChunkName: "so-index" */ '@/view/pages/service-orders/index.vue'
  );
const ServiceOrderList = () =>
  import(
    /* webpackChunkName: "so-list" */ '@/view/pages/service-orders/List.vue'
  );
const ServiceOrderUpsert = () =>
  import(
    /* webpackChunkName: "so-upsert" */ '@/view/pages/service-orders/Upsert.vue'
  );
const ServiceOrderDetail = () =>
  import(
    /* webpackChunkName: "so-detail" */ '@/view/pages/service-orders/Detail.vue'
  );
const ServiceOrderIntake = () =>
  import(
    /* webpackChunkName: "so-intake" */ '@/view/pages/service-orders/VehicleIntake.vue'
  );
const ServiceOrderQuote = () =>
  import(
    /* webpackChunkName: "so-quote" */ '@/view/pages/service-orders/QuotationEdit.vue'
  );

export default [
  {
    path: '/service-orders',
    component: ServiceOrder,
    children: [
      {
        path: '/',
        name: 'list-service-order',
        component: ServiceOrderList,
        meta: {
          title: 'Phiếu dịch vụ',
        },
      },
      {
        path: 'intake',
        name: 'intake-service-order',
        component: ServiceOrderIntake,
        meta: {
          title: 'Tiếp nhận xe',
        },
      },
      {
        path: 'create',
        name: 'create-service-order',
        component: ServiceOrderUpsert,
        meta: {
          title: 'Tạo Phiếu dịch vụ',
        },
      },
      {
        path: ':id/edit',
        name: 'edit-service-order',
        component: ServiceOrderUpsert,
        meta: {
          title: 'Sửa Phiếu dịch vụ',
        },
        props: true,
      },
      {
        path: ':id/quote',
        name: 'quote-service-order',
        component: ServiceOrderQuote,
        meta: {
          title: 'Báo giá Phiếu dịch vụ',
        },
        props: true,
      },
      {
        path: ':id',
        name: 'detail-service-order',
        component: ServiceOrderDetail,
        meta: {
          title: 'Chi tiết Phiếu dịch vụ',
        },
        props: true,
      },
    ],
  },
];
